/**
 * Из оригинального slaveName («Виктория фри Кита 3 Слейв») делает компактное
 * отображение подписи под именем модели: «фри 3», «фри 9», «платка».
 * modelDisplayName вида «Base» или «Base (Creator)» — creator дублировать не
 * нужно, он уже в заголовке.
 */

const TYPE_RE = /^(фри|платка|free|paid|премиум|premium)$/i;
const NUM_RE = /^\d+(?:-\d+)?$/;

function escapeRe(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function splitDisplayName(displayName: string): { base: string; parentCreator: string | null } {
  const m = /^(.+?)\s*\((.+)\)\s*$/.exec(displayName.trim());
  if (m) return { base: m[1]!.trim(), parentCreator: m[2]!.trim() };
  return { base: displayName.trim(), parentCreator: null };
}

export function formatSubName(slaveName: string, modelDisplayName: string): string {
  const { base, parentCreator } = splitDisplayName(modelDisplayName);
  let s = slaveName.trim();

  // 1. Убираем base из начала
  const startRe = new RegExp('^' + escapeRe(base) + '(?:\\s|$)', 'i');
  s = s.replace(startRe, '').trim();

  // 2. Аддоны «+ N Xxxx» / «+ N»
  s = s.replace(/[+＋]\s*\d+(?:\s+[а-яА-ЯёЁa-zA-Z]+)?/gi, ' ');
  s = s.replace(/(?:^|\s)[+＋](?=\s|$)/g, ' ');

  // 3. «N акка на»
  s = s.replace(/(?:^|\s)\d+\s+акк(?:а|ов|у)?\s+на(?=\s|$)/gi, ' ');

  // 4. «Слейв» / «Slave» / «Cлейв»
  s = s.replace(/(?:^|\s)[СсCc]лейв(?=\s|$)/g, ' ');
  s = s.replace(/(?:^|\s)Slave(?=\s|$)/gi, ' ');

  s = s.replace(/\s+/g, ' ').trim();
  if (!s) return '';

  // 5. Разбор: тип + номер + creator
  const tokens = s.split(/\s+/);
  let type: string | null = null;
  let num: string | null = null;
  const creator: string[] = [];
  for (const t of tokens) {
    if (!type && TYPE_RE.test(t)) { type = t.toLowerCase(); continue; }
    if (TYPE_RE.test(t)) continue;
    if (!num && NUM_RE.test(t)) { num = t; continue; }
    creator.push(t);
  }

  // 6. Не показывать creator, если он совпадает с уже указанным в скобках displayName
  const filteredCreator = parentCreator
    ? creator.filter((c) => c.toLowerCase() !== parentCreator.toLowerCase())
    : creator;

  const parts: string[] = [];
  if (type) parts.push(type);
  if (num) parts.push(num);
  let out = parts.join(' ');
  if (filteredCreator.length) out += (out ? ' ' : '') + '(' + filteredCreator.join(' ') + ')';
  return out;
}
